import React from 'react';
import { G, Path } from 'react-native-svg';

import { IconDef } from './types';

export const Print: IconDef = {
  svg: (
    <G>
      <Path d="M17.9943 17.7881V19.104C17.9943 20.4121 16.9873 21.4727 15.7451 21.4727H8.24778C7.00558 21.4727 5.99858 20.4121 5.99858 19.104V17.787L4.2492 17.7882C3.007 17.7882 2 16.7277 2 15.4195V9.1068C2 7.21721 3.45455 5.68541 5.24885 5.68541L5.99758 5.6848L5.99858 4.89209C5.99858 3.58392 7.00558 2.52344 8.24778 2.52344H15.7476C16.9898 2.52344 17.9968 3.58392 17.9968 4.89209L17.9963 5.6848L18.7466 5.68541C20.5403 5.68725 21.994 7.21734 21.9967 9.1056L22 15.4191C22.0019 16.7267 20.9954 17.7883 19.7528 17.789L17.9943 17.7881ZM15.7451 13.5771H8.24778C7.83372 13.5771 7.49805 13.9307 7.49805 14.3667V19.104C7.49805 19.54 7.83372 19.8936 8.24778 19.8936H15.7451C16.1592 19.8936 16.4949 19.54 16.4949 19.104V14.3667C16.4949 13.9307 16.1592 13.5771 15.7451 13.5771ZM15.7476 4.10254H8.24778C7.83372 4.10254 7.49805 4.45604 7.49805 4.89209L7.49705 5.6848H16.4969L16.4974 4.89209C16.4974 4.45604 16.1617 4.10254 15.7476 4.10254Z" />
    </G>
  ),
  svgStyles(color) {
    return {
      fill: color,
      strokeWidth: 0,
    };
  },
};
